import { useEffect, useState } from 'react';
import { useApi } from '../../../utils/hooks';
import { ISystemCodeByTypeDto } from '../../../utils/constants/interfaces';

// Hook to fetch member status codes from the API
const useMemberStatusLookup = () => {
  const api = useApi();
  const [statusOptions, setStatusOptions] = useState<ISystemCodeByTypeDto[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadMemberStatuses = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.get<ISystemCodeByTypeDto[]>(
          '/codes/code-types-by-type/MEMBER_STATUS'
        );
        if (response?.isSuccessStatusCode && response.response) {
          setStatusOptions(response.response);
        } else {
          setError('Failed to load member status options');
          setStatusOptions([]);
        }
      } catch (err) {
        setError('Error loading member status options');
        setStatusOptions([]);
      } finally {
        setLoading(false);
      }
    };

    void loadMemberStatuses();
  }, [api]);

  return {
    statusOptions,
    loading,
    error
  };
};

export default useMemberStatusLookup;
